import Navbar from "../layouts/Navbar";
import Body from "../layouts/Body";

const IndexPage = (): JSX.Element => {
    return (
        <main>
            <Navbar />
            <Body />
        </main>
    );
};

export default IndexPage;
